import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import UserService from "../../services/user.service";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import ToastBlockContainer from "../../common/ToastBlockContainer";
import Loading from "../../common/Loading";
import Avatar from "../../assets/images/avatar.svg";

const ViewTaskDetails = (props) => {
  let history = useHistory();
  var UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
  let { uuid, taskId, userUUID } = useParams();
  const [showDelete, setShowDelete] = useState(false);
  const [taskUrl, setTaskUrl] = useState("");
  const [taskEditUrl, setTaskEditUrl] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [successToast, setSuccessToast] = useState(false);
  const [allValue, setAllValue] = useState([]);
  const [clickVal, setClickVal] = useState({});
  const abc = parseInt(localStorage.getItem("taskID"));
  const [loader, setLoader] = useState(true);
  const [timeZone, setTimeZone] = useState(0);

  useEffect(() => {
    const offsetInMinutes = new Date().getTimezoneOffset();
    setTimeZone(offsetInMinutes);
    // check time
    // get family details
    setLoader(true);
    if (userUUID) {
      setTaskUrl("/user_todos/" + uuid + "/" + userUUID);
    } else {
      setTaskUrl("/todos/" + uuid);
    }
    // get single warranty details by ID

    UserService.getUserSingleFamilyDetails(uuid, UserDetails.id).then(
      (response) => {
        if (userUUID) {
          UserService.getTaskDetailsById(taskId).then((respo) => {
            UserService.getTaskDetailsByParentId(
              taskId,
              respo.data.FamilyUserId,
              respo.data.FamilyId
            ).then((res) => {
              console.log(res.data);
              setAllValue(res.data);
              if (res.data.length > 1) {
                let activeItem = null;
                const lastItem = res.data[res.data.length - 1];
                for (let i = 0; i < res.data.length; i++) {
                  if (res.data[i].status === "Active") {
                    activeItem = res.data[i];
                    break; // Stop looping once we find an active item
                  }
                }
                setClickVal(activeItem ? activeItem : lastItem);
              } else {
                setClickVal(res.data[0]);
              }
            });
            setTaskEditUrl(
              "/edit_user_todos/" + uuid + "/" + taskId + "/" + userUUID
            );
          });
        } else {
          UserService.getTaskDetailsByParentId(
            taskId,
            response.FamilyData.id,
            response.FamilyData.FamilyId
          ).then(
            (resp) => {
              console.log(resp);
              setAllValue(resp.data);
              if (resp.data.length > 1) {
                let activeItem = null;
                const lastItem = resp.data[resp.data.length - 1];
                for (let i = 0; i < resp.data.length; i++) {
                  if (resp.data[i].status === "Active") {
                    activeItem = resp.data[i];
                    break; // Stop looping once we find an active item
                  }
                }
                setClickVal(activeItem ? activeItem : lastItem);
              } else {
                setClickVal(resp.data[0]);
              }

              setTaskEditUrl(
                "/edit_todos/" + uuid + "/" + taskId //+ response.data.rows[0].id
              );
            },
            () => {}
          );
        }
        setTimeout(() => {
          setLoader(false);
        }, 3000);
      },
      () => {}
    );
  }, []);

  console.log(clickVal);
  console.log(allValue);

  // Delete confirmation
  const handleShowDeleteShow = () => {
    setShowDelete(true);
    //setGiftId(id);
  };

  // Close delete confirmation
  const handleShowDeleteClose = () => {
    setShowDelete(false);
  };

  const noImgError = (e) => {
    e.target.setAttribute("src", Avatar);
  };

  // Delete task
  const handleDeleteTodo = (aaa) => {
    setShowDelete(false);

    UserService.deleteTask(aaa).then(
      () => {
        setShowToast(true);
        setSuccessToast(true);
        setToastMessage("To Do deleted successfully");
        window.scrollTo(0, 0);

        setTimeout(() => {
          history.push(`/todos/${uuid}`);
        }, 2500);
      },
      () => {}
    );
  };

  const [showMarkTodo, setShowMarkTodo] = useState(false);
  const [markTodoObj, setMarkTodoObj] = useState({});
  // show the mark to as completed modal
  const showTodo = (aaa) => {
    setMarkTodoObj(aaa);
    setShowMarkTodo(true);
  };

  // hide mark to do as completed modal
  const handleMarkTodoHide = () => {
    setShowMarkTodo(false);
  };

  // update task status to complete
  const updateTaskStatus = () => {
    let data = {
      status: "Completed",
    };
    UserService.updateTaskAsComplete(data, markTodoObj.id).then(
      (response) => {
        setShowMarkTodo(false);
        window.scrollTo(0, 0);

        if (response.status === 400) {
          setSuccessToast(false);
          setShowToast(true);
          setToastMessage(response.data.message);
        } else {
          setShowToast(true);
          setSuccessToast(true);
          setToastMessage("To Do mark as complete successfully");
          setTimeout(() => {
            window.location.reload();
          }, 2500);
        }
      },
      () => {}
    );
  };

  const validateDate = (date) => {
    // Get today's date
    const today = new Date();

    // Create the target date from the ISO string
    const targetDate = new Date(date);

    // Calculate the time difference in milliseconds
    const timeDifference = targetDate - today;

    // Convert the time difference from milliseconds to days
    const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

    return daysDifference;
  };

  return (
    <Container>
      <ToastBlockContainer
        successToast={successToast}
        showToast={showToast}
        setShowToast={setShowToast}
        toastMessage={toastMessage}
      />
      <Row className="justify-content-center gy-0 mb-6rem">
        <Col xl="21" xxl="18">
          <h1 className="lh-base mb-4">To-do</h1>
          <section className="bg-white p-4 p-md-6 p-lg-8 shadow rounded-4">
            {loader ? (
              <>
                <Loading />
              </>
            ) : (
              <>
                <section>
                  <Row className="gy-3 gy-md-4 gy-lg-0 mb-3 mb-md-4">
                    <Col xs="auto" className="order-lg-last ms-auto">
                      {clickVal && !clickVal.taskRecurrence && (
                        <>
                          <Link
                            to={taskEditUrl}
                            className="btn btn-white btn-sm btn-square d-inline-flex d-md-none"
                          >
                            <i className="fa-solid fa-edit"></i>
                          </Link>
                          <Link
                            to={taskEditUrl}
                            className="btn btn-white btn-sm d-none d-md-inline-block"
                          >
                            <i className="fa-solid fa-edit me-2"></i>Edit
                          </Link>
                        </>
                      )}
                      {clickVal && clickVal.status !== "Completed" && (
                        <>
                          <button
                            onClick={() => showTodo(clickVal)}
                            className="btn btn-white btn-sm btn-square d-inline-flex d-md-none ms-2"
                          >
                            <i className="fa-solid fa-check"></i>
                          </button>
                          <button
                            onClick={() => showTodo(clickVal)}
                            className="btn btn-white btn-sm d-none d-md-inline-block ms-2"
                          >
                            <i className="fa-solid fa-check me-2"></i>Mark as
                            completed
                          </button>
                        </>
                      )}

                      <Button
                        variant="danger"
                        size="sm"
                        className="btn-square d-inline-flex ms-2"
                        onClick={() =>
                          props.location.state
                            ? handleShowDeleteShow(props.location.state)
                            : handleShowDeleteShow(abc)
                        }
                      >
                        <i className="fa-solid fa-trash text-white"></i>
                      </Button>
                    </Col>
                  </Row>
                  <Row className="gy-3 gy-md-4 gy-lg-0 mb-6">
                    <Col>
                      <h2
                        className={`word-break ${
                          clickVal && clickVal.details
                            ? "mb-1 mb-md-2 "
                            : "mb-0 "
                        }`}
                      >
                        {clickVal && clickVal.name}
                      </h2>
                      {clickVal && clickVal.details !== "" && (
                        <p className="mb-0 word-break">
                          {clickVal
                            ? clickVal.details
                              ? clickVal.details
                              : "--"
                            : ""}
                        </p>
                      )}
                    </Col>
                  </Row>
                  <Row className="gy-3 gy-md-0 mb-3 mb-md-4">
                    {/* unless lg breakpoint */}
                    <Col md="12" className=" d-md-none">
                      <div className="small fw-medium">Date</div>
                      <p
                        className={`h2  ${
                          validateDate(clickVal.eta) <= 30
                            ? "text-danger"
                            : validateDate(clickVal.eta) <= 60 &&
                              validateDate(clickVal.eta) > 30
                            ? "text-orange"
                            : validateDate(clickVal.eta) <= 90 &&
                              validateDate(clickVal.eta) > 60
                            ? "text-lightgreen"
                            : "text-success"
                        } fw-semibold text-truncate`}
                      >
                        {moment(clickVal.eta).isValid()
                          ? moment(
                              new Date(clickVal.eta).setMinutes(
                                new Date(clickVal.eta).getMinutes() + timeZone // 5 hours 30 minutes = 330 minutes (UTC)
                              )
                            ).format("DD/MM/YYYY h:mm A")
                          : "--"}
                      </p>
                    </Col>
                    {/* if lg breakpoint */}
                    <Col md="12" className=" d-none d-md-block">
                      <div className="small fw-medium">Date</div>
                      <p
                        className={`h2  ${
                          validateDate(clickVal.eta) <= 30
                            ? "text-danger"
                            : validateDate(clickVal.eta) <= 60 &&
                              validateDate(clickVal.eta) > 30
                            ? "text-orange"
                            : validateDate(clickVal.eta) <= 90 &&
                              validateDate(clickVal.eta) > 60
                            ? "text-lightgreen"
                            : "text-success"
                        } fw-semibold text-truncate`}
                      >
                        {moment(clickVal.eta).isValid()
                          ? moment(
                              new Date(clickVal.eta).setMinutes(
                                new Date(clickVal.eta).getMinutes() + timeZone // 5 hours 30 minutes = 330 minutes (UTC)
                              )
                            ).format("DD/MM/YYYY h:mm A")
                          : "--"}
                      </p>
                    </Col>
                    <Col>
                      <div className="small fw-medium">Days to complete</div>
                      <p
                        className={`h2  ${
                          validateDate(clickVal.eta) <= 30
                            ? "text-danger"
                            : validateDate(clickVal.eta) <= 60 &&
                              validateDate(clickVal.eta) > 30
                            ? "text-orange"
                            : validateDate(clickVal.eta) <= 90 &&
                              validateDate(clickVal.eta) > 60
                            ? "text-lightgreen"
                            : "text-success"
                        } fw-semibold text-truncate`}
                      >
                        {validateDate(clickVal.eta) < 0
                          ? "Expired"
                          : validateDate(clickVal.eta) === 0
                          ? "0 days "
                          : validateDate(clickVal.eta) === 1
                          ? "1 day "
                          : `${validateDate(clickVal.eta)} days `}
                      </p>
                    </Col>
                  </Row>
                  <Row className="gy-3 gy-md-0 mb-3 mb-md-4">
                    <Col md="8">
                      <div className="small fw-medium">Status</div>
                      <div className="text-dark fw-semibold">
                        {allValue.some((item) => item.status === "Active")
                          ? "Active"
                          : "Completed"}
                      </div>
                    </Col>
                  </Row>
                  <Row className="gy-3 gy-md-0">
                    {clickVal && clickVal.taskRecurrence ? (
                      <>
                        <Col md="8">
                          <div className="small fw-medium">Frequency</div>
                          <p className="text-dark fw-medium mb-0">
                            {clickVal && clickVal.taskFrequency}
                          </p>
                        </Col>
                        <Col md="8">
                          <div className="small fw-medium">Occurrences</div>
                          <p className="text-dark fw-medium mb-0">
                            {allValue ? allValue.length : ""}
                          </p>
                        </Col>
                      </>
                    ) : (
                      ""
                    )}
                    <Col md="8">
                      <div className="small fw-medium">Assignee</div>
                      <div className="d-flex align-items-center">
                        <div className="avatar avatar-sm flex-shrink-0 me-3">
                          <Image
                            src={clickVal && clickVal.assigneeId.User.avatar}
                            onError={noImgError}
                            alt="Profile Avatar"
                          />
                        </div>
                        <p className="text-dark fw-medium mb-0">
                          {clickVal && clickVal.assigneeId
                            ? clickVal.assigneeId.User.firstName === "null"
                              ? clickVal.assigneeId.User.email
                              : clickVal.assigneeId.User.firstName +
                                " " +
                                clickVal.assigneeId.User.lastName
                            : ""}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </section>
                {clickVal && clickVal.taskRecurrence ? (
                  <>
                    <hr className="my-6 my-md-7" />
                    <section>
                      <h3 className="mb-1 mb-md-2">History</h3>
                      {/* <p class="mb-3 mb-md-4">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry.
                      </p> */}
                      <Row className="gy-3 gy-md-0 mb-6">
                        <Col md="8">
                          <div className="small fw-medium">
                            Previous completions
                          </div>
                          <p className="text-dark fw-semibold mb-0">
                            {
                              allValue.filter(
                                (task) => task.status === "Completed"
                              ).length
                            }
                          </p>
                        </Col>
                        <Col md="8">
                          <div className="small fw-medium">
                            Previous expired
                          </div>
                          <p className="text-dark fw-semibold mb-0">
                            {
                              allValue.filter(
                                (task) => task.status === "Expired"
                              ).length
                            }
                          </p>
                        </Col>
                        <Col md="8">
                          <div className="small fw-medium">Upcoming</div>
                          <p className="text-dark fw-semibold mb-0">
                            {
                              allValue.filter(
                                (task) => task.status === "Upcoming"
                              ).length
                            }
                          </p>
                        </Col>
                      </Row>
                      {allValue.map((allVal, index) => (
                        <>
                          <Row className="">
                            <Col md="14" xl="16" xxl="20" className="me-auto">
                              <div
                                className={`d-flex align-items-center ${
                                  allVal.status === "Completed"
                                    ? "opacity-25"
                                    : ""
                                }`}
                              >
                                <div className="small fw-semibold text-dark d-md-none">
                                  {allVal.name}
                                </div>
                                <div className="fw-semibold text-dark d-none d-md-block">
                                  {allVal.name}
                                </div>
                              </div>
                              <div
                                className={`small text-truncate d-md-none mt-2 ${
                                  allVal.status === "Completed"
                                    ? "opacity-25"
                                    : ""
                                }`}
                              >
                                {allVal.details}
                              </div>
                              <div
                                className={`small text-truncate d-none d-md-block mt-2 ${
                                  allVal.status === "Completed"
                                    ? "opacity-25"
                                    : ""
                                }`}
                              >
                                {allVal.details}
                              </div>
                              <div
                                className={`small fw-semibold d-md-none mt-2 ${
                                  allVal.status === "Completed"
                                    ? "opacity-25 mb-1"
                                    : ""
                                } ${
                                  allVal.status === "Expired"
                                    ? "text-danger mb-1"
                                    : "text-dark"
                                }`}
                              >
                                {moment(
                                  new Date(allVal.eta).setMinutes(
                                    new Date(allVal.eta).getMinutes() + timeZone // 5 hours 30 minutes = 330 minutes (UTC)
                                  )
                                ).format("DD/MM/YYYY h:mm A")}
                              </div>
                              <div
                                className={`fw-semibold mt-2 ${
                                  allVal.status === "Completed"
                                    ? "text-success"
                                    : ""
                                } d-inline d-md-none small`}
                              >
                                {allVal.status}
                              </div>
                            </Col>

                            <Col
                              md="10"
                              xl="8"
                              xxl="4"
                              className={`text-end d-none d-md-flex align-items-center justify-content-end gap-4 ${
                                allVal.status === "Completed"
                                  ? "opacity-25"
                                  : ""
                              }`}
                            >
                              <div
                                className={`fw-semibold ${
                                  allVal.status === "Completed"
                                    ? "text-success"
                                    : ""
                                } d-inline small`}
                              >
                                {allVal.status}
                              </div>
                              <div
                                className={`small fw-semibold ${
                                  allVal.status === "Expired"
                                    ? "text-danger"
                                    : "text-dark"
                                }`}
                              >
                                {allVal.eta !== null &&
                                allVal.eta !== undefined &&
                                moment(allVal.eta).isValid()
                                  ? moment(
                                      new Date(allVal.eta).setMinutes(
                                        new Date(allVal.eta).getMinutes() +
                                          timeZone // 5 hours 30 minutes = 330 minutes (UTC)
                                      )
                                    ).format("DD/MM/YYYY h:mm A")
                                  : "--"}
                              </div>
                            </Col>
                          </Row>
                          {index !== allValue.length - 1 && (
                            <hr className="my-3" />
                          )}
                        </>
                      ))}
                    </section>
                  </>
                ) : (
                  <></>
                )}
              </>
            )}
          </section>
        </Col>
      </Row>

      {/* // Delete Gift cards */}
      <Modal
        show={showDelete}
        onHide={handleShowDeleteClose}
        className="invite_au_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h2 className="h3 mb-0">Delete To Do</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>All the to do's related details will be deleted from the family</p>
          <p className="mb-5">Do you want to continue?</p>
          <Button onClick={handleShowDeleteClose} className="btn btn-white">
            Cancel
          </Button>
          <Button
            onClick={() =>
              props.location.state
                ? handleDeleteTodo(props.location.state)
                : handleDeleteTodo(abc)
            }
            className="ms-4 btn btn-primary"
          >
            Yes
          </Button>
        </Modal.Body>
      </Modal>

      {/* // Mark Todo as completed */}
      <Modal show={showMarkTodo} onHide={handleMarkTodoHide} className="">
        <Modal.Header closeButton>
          <Modal.Title>
            <h2 className="h3 mb-0">Mark To-do as completed</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Mark the To-do to be completed from the family</p>
          <p className="mb-5">Do you want to continue?</p>
          <Button className="btn btn-white" onClick={handleMarkTodoHide}>
            Cancel
          </Button>
          <Button
            onClick={() => updateTaskStatus()}
            className="ms-4 btn btn-primary"
          >
            Yes
          </Button>
        </Modal.Body>
      </Modal>
    </Container>
  );
};
export default ViewTaskDetails;
